import styled from '@emotion/styled'
import React from 'react'

import { HEADER_HEIGHT_VALUES } from '../constants'
import { HeaderSection } from '../containers/HeaderSection'
import { IHeader } from '../graphql/sections/header'
import mq from '../styles/breakpoints'
import PreviewBanner, { PREVIEW_BANNER_BREAKPOINT, PREVIEW_BANNER_HEIGHT, usePreviewBanner } from './PreviewBanner'
import SnackBar from './SnackBar'
import { FrenchLinks } from './FrenchLinks'

// The header is `position: fixed` with no `top`, so it sits at its static position. Padding
// the wrapper is what pushes it (and the rest of the page) below the preview banner.
const LayoutWrapper = styled.div<{ hasPreviewBanner: boolean }>`
  margin: auto;
  ${({ hasPreviewBanner }) =>
    hasPreviewBanner
      ? `@media (min-width: ${PREVIEW_BANNER_BREAKPOINT}px) { padding-top: ${PREVIEW_BANNER_HEIGHT}px; }`
      : ''}
`
const HeaderSaveArea = styled.div`
  ${mq({
    height: [
      `${HEADER_HEIGHT_VALUES.MOBILE}px`,
      `${HEADER_HEIGHT_VALUES.TABLET}px`,
      `${HEADER_HEIGHT_VALUES.DESKTOP}px`,
    ],
  })}
`

type LayoutProps = {
  // The page query result, from `wrapPageElement`. Absent on code pages (blog archive, 404).
  data?: { contentfulPage?: { customHeader?: IHeader | null } }
}

const Layout: React.FC<LayoutProps> = ({ children, data }) => {
  const showPreviewBanner = usePreviewBanner()

  return (
    <FrenchLinks>
      <LayoutWrapper hasPreviewBanner={showPreviewBanner}>
        {showPreviewBanner && <PreviewBanner />}
        <HeaderSection customHeader={data?.contentfulPage?.customHeader ?? null} />
        <SnackBar />
        <HeaderSaveArea />
        {children}
      </LayoutWrapper>
    </FrenchLinks>
  )
}

export default Layout
